<div class="input-container" (click)="input.setFocus()">
  <ion-label>Please enter your response</ion-label>

  <ion-textarea
    #input
    type="text"
    rows="4"
    auto-grow="true"
    autocapitalize="on"
    maxlength="500"
    [formControl]="field"
    (click)="onClick($event)"></ion-textarea>
</div>
<ion-item class="character-count" lines="none">{{ length }}/500</ion-item>
